module.exports = __webpack_public_path__ + "img/coupon_url.a6e38393.png";